/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React, { useRef } from 'react';
import { Modal, Button } from 'antd';

enum AgreementType {
  SERVICE = 'service',
  PRIVACY = 'privacy',
}

interface AgreementModalProps {
  visible: boolean;
  onClose: () => void;
  type: AgreementType;
  onAgree: () => void;
}

function AgreementModal(props: AgreementModalProps) {
  const {
    visible,
    onClose,
    type,
    onAgree,
  } = props;
  const contentRef = useRef<HTMLDivElement>(null);

  const getContent = () => {
    if (type === AgreementType.SERVICE) {
      return (
        <div>
          <h2>不动产服务协议</h2>
          <p>
            <strong>重要提示：</strong>
            重要提示：本协议由北京新橙科技有限公司（以下统称为“本公司”）制定，本协议自公布之日起生效。凡申请成为iLaw不动产查询系统的注册用户或使用本公司所提供的产品与服务（以下统称为“不动产产品与服务”），均视为已全部阅读、全部理解本协议的内容，并同意接受所有条款的约定。
          </p>
          <p>在您使用本产品及服务之前，您须确保您已具有完全民事行为能力，能够同意和履行本协议，否则请勿使用本服务。如果您代表您的雇主或其他法律主体同意本条款，您声明您必须有充分的法律授权，且有权使您的雇主或该法律主体受到本条款的约束。</p>

          <h3>1. 服务提示</h3>
          <p>1.1 账号注册。用户使用不动产产品与服务前，应先行按照指引完成账号注册，并确保所填写的信息合法、真实、准确、完整，不得冒用他人信息或使用可能侵犯他人权益的信息；注册完成后，请妥善保管账号及密码，如出现账号被盗用或泄露的情况，请及时与本公司取得联系；</p>
          <p>1.2 文件上传。用户可在不动产查询系统服务中上传、存储文件及其他数据资料。基于法律法规的规定，任何主体均不得上传或散布任何违法或侵犯他人合法权益的内容（包括但不限于涉及国家秘密或安全、违反国家民族与宗教政策、带有淫秽、色情、恐吓等违法信息）。如因用户违反前述规定而引发侵权风险或产生任何纠纷，相关不利后果需由用户自行承担并赔偿本公司因此造成的全部损失。</p>

          <h3>2. 版权声明与使用授权</h3>
          <p>2.1 本公司提供的不动产查询系统等所有服务及内容，包括但不限于服务中所使用的相关软件、数据库、信息资料等的版权及其他权利，属于本公司或者提供资料的第三方所有，均受中华人民共和国著作权法、商标法、专利法等相关法律法规以及国际条约的保护；</p>
          <p>2.2 本服务的用户将被授予非独占性、不可转让的有限权利，用户可以使用本公司提供的信息查询服务、资料下载与使用等服务，但无权对本公司所提供的服务、资料等相关产品主张任何权利；</p>
          <p>2.3 用户可通过本服务上传、存储案例文件等数据资料，相关内容的知识产权归属原作者所有，并可在不动产产品与服务中进行公开与共享。任何主体均不得以违反法律法规的方式使用其他用户所共享的数据资料；</p>
          <p>2.4 任何主体均不得以损害本公司的方式使用软件、数据库及相关信息资料，未经书面许可，任何机构及个人不得超出正常学习、工作、科研使用范围，抄袭、仿照本数据库检索方法，以及利用电子、机械或其他方式，复印、翻印、再版、上传、传播、删改本公司数据库等不动产产品与服务的任何部分或者全部信息资料，亦不得使用超级链路连接、传送、存储，或以"镜象链接"等方式，将其载入其他信息检索系统及其他服务器或网站上，用于其他目的；</p>
          <p>2.5 严禁任何主体以任何理由访问本公司的计算机系统，或对本软件进行反向工程、反编译等操作，且禁止以任何目的使用网络爬虫或其他的自动化程序获取不动产产品与服务的内容，或者获取他人的个人信息；</p>
          <p>2.6 本公司所提供的软件、产品及服务，所使用和显示的商标、商品名称、服务标记，包括但不限于设计、配色方案、文本、图片和视频等，均属本公司或其他第三方所有，未经本公司或其他版权所有人事先书面许可,任何人不得擅自使用、复制和仿造，否则需对本公司及其他第三人造成的全部损失承担法律责任。</p>

          <h3>3. 服务更新与提示</h3>
          <p>3.1 为了完善功能服务，我们将不断进行开发和优化，并不时地提供软件或网页服务的更新（更新内容包括功能的新增、修改、版本更新等）。为了保障您使用体验的流畅性和一致性，您同意我们采用网页公告、电子邮件、手机短信等方式向您进行服务提示和服务更新的推送，同时，我们也有权在不向您进行特别通知的情况下对软件进行更新或对部分功能进行调整；</p>
          <p>3.2 我们会基于产品的设计升级功能服务，故在新版本软件或网页服务上线后，旧版本中的部分功能可能有所调整，请您以最新版本的功能情况为准。并请您注意在官方渠道中下载与您终端设备兼容的软件版本，否则因版本不适配所引发的使用问题或损害，需由您自行承担；</p>

          <h3>4. 个人信息保护</h3>
          <p>在您注册账号及使用本服务的过程中，需要基于功能服务实现的必要提供一些个人信息，我们仅会将其用于实现服务的目的。除非法律法规另有规定，否则未经您的许可，我们不会将相关信息向其他第三方进行共享。此外，我们还会采取合理的安全措施与管理制度，保护您的个人信息免遭未经授权的访问、使用或披露。关于个人信息收集、使用、处理、保护的具体条款，以及您对个人信息的法定权利等说明，请详见《iLaw不动产隐私协议》</p>

          <h3>5. 免责声明</h3>
          <p>5.1 本公司所提供的不动产查询产品服务，目的在于方便用户查询使用，但我们不保证所提供任何信息资料的准确性、有效性、完整性，用户对所提供的信息在正式使用前的准确性、有效性、完整性负有审查义务；</p>
          <p>5.2 本公司力求所提供的相关信息产品服务来自可信赖的合理渠道，属客观如实反映，但不保证其适合于任何特定场景下的用途，更不代表专业性意见或正式咨询意见，包括其他用户通过本网站及软件提交的各种文件、评论及相关信息在内，用户均应自行判断所浏览及获取信息的参考价值，并在与正式文件、司法文书等核对后慎重使用，并自行承担法律后果和责任；</p>
          <p>5.3 本公司致力于不断提升系统与服务能力，但无法保证服务不出现任何技术故障，如因系统维护升级、电信设备故障、黑客攻击、网络升级、以及台风、海啸、洪水、停电等不可预见或不能避免的因素导致不动产产品与服务出现中断、延迟或致使数据丢失和受损的，您理解并同意此为基于行业技术服务的现有水平所无法避免的情况，不视为本公司违约，同时本公司也无需承担损害赔偿责任；</p>
          <p>5.4 任何主体如发现不动产产品与服务中所提供的内容侵害了其合法权益，请备好相应的证明材料并及时联系本公司，以便进行核实并对侵权内容采取删除或屏蔽等处理措施。</p>

          <h3>6. 第三方服务</h3>
          <p>6.1 本公司所提供的不动产查询系统等信息产品服务中可能包含指向其他网站或资源的超链接，本公司不保证超链接可访问到的第三方资料之准确性、完整性、时效性，亦不承担任何责任。如您选择通过超链接访问第三方的网站与服务，请注意查阅其所出示的服务条款与隐私政策，以保障您的合法权益。如因本服务中的第三方服务或技术引发纠纷，需由对应的第三方负责解决；</p>
          <p>6.2 在使用本服务过程中所产生的话费及流量费用等，均由第三方通信运营商收取。如您对通信运营商所提供的网络服务或所收取的费用存在疑问，请您自行联系对应的运营商进行处理。</p>

          <h3>7. 违约处理</h3>
          <p>如果我们发现或经他人投诉举报，有用户违反本协议约定的，例如：以侵犯他人知识产权、冒用他人的身份的方式使用本服务，或破坏本服务的系统等。经核实，我们将有权视违约行为对本服务的影响程度及情节的严重性，对违约用户采取内容删除、屏蔽、断开链接或账号封禁等处理。情节严重者，我们将保留追究法律责任的权利。</p>

          <h3>8. 其他</h3>
          <p>8.1 本公司保留随时修改、变更、增加、删除本协议内容的权利，且无需进行事先通知，但我们会即时地予以公布，并通过网页提示、网页公告、软件更新信息提示等可行的方式提示您，您可以在不动产官方网站或软件中查阅最新版本的相关协议条款。如果您在本协议条款修改后仍选择使用不动产产品与服务，则表示您同意接受相关内容的修改；</p>
          <p>8.2 本协议的订立、执行和解释及争议的解决均应适用中国法律。如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可将争议提交至北京仲裁委员会；</p>
          <p>8.3 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
          <p>8.4 您可以通过邮件（iLawhegui@icourt.cc）与我们联系。</p>
          <p style={{ textAlign: 'right' }}>北京新橙科技有限公司</p>
          <p style={{ textAlign: 'right' }}>2025年9月2日</p>
        </div>
      );
    }
    return (
      <div>
        <h2>不动产服务隐私政策</h2>
        <p>
          <strong>更新日期：2025年9月2日</strong>
          <br />
          <strong>生效日期：2025年9月2日</strong>
        </p>

        <p>尊敬的用户：</p>
        <p>您好，欢迎您使用iLaw不动产查询系统！</p>

        <p>本隐私政策仅适用于北京新橙科技有限公司（注册地址：北京市朝阳区高碑店乡西店村49号楼四层4032，以下简称“iLaw”或“我们”）的iLaw不动产查询系统。本隐私政策不适用于我们作为受托人在iLaw不动产查询系统中存储或托管的您的多媒体文件。“您的多媒体文件”是指由您和/或您的最终用户在本服务中上传、存储或处理的所有图片、文字、材料、您的客户信息等内容，对此我们仅作托管和存储，不会进行读取、使用。</p>

        <p>如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：</p>
        <p>电话：010-57105670</p>
        <p>电子邮箱：icourt@icourt.cc</p>

        <p>iLaw尊重并致力于保护用户的隐私权，严格遵守法律法规、遵循以下隐私保护规则，恪守权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则，以期为您提供更加安全、可靠的服务。</p>

        <p>用户在注册、使用本服务的相关功能时，需要依据功能运作的必要而提供相应信息。为了使您了解我们所需要的信息以及所采取的安全措施，请您在使用我们的产品服务之前，仔细阅读并理解本隐私政策。</p>

        <p>本隐私政策将帮助您了解以下内容，您可以根据目录指引详细阅读相应条款：</p>
        <ol>
          <li>如何收集、使用您的信息</li>
          <li>如何委托处理、共享、转让、公开披露您的信息</li>
          <li>如何存储、保护您的信息</li>
          <li>如何使用Cookie技术</li>
          <li>关于您的权利</li>
          <li>未成年人信息保护</li>
          <li>本隐私政策更新</li>
          <li>如何联系我们</li>
        </ol>

        <h3>1. 如何收集、使用您的信息</h3>
        <p>个人信息是指以电子或其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。在您使用本服务时，我们将按照如下方式和目的、根据您所选择服务运行的必要性，收集和使用您所提交的信息：</p>

        <p>1.1 当您以个人用户身份登陆iLaw不动产账号时，我们需要收集您所填写的用户名、手机号码、邮箱地址、角色信息，以便我们与您联系，完成账号的注册及提供您所需的服务，并在服务页面上向您进行展示。</p>

        <p>1.2 当您以企业用户（如律所、公司）身份，统一为最终使用的个人用户（如律师、员工）开通iLaw不动产账号时，您需确认所提交的用户信息已获得个人信息主体的明确授权。我们也会在您的最终用户启用本服务、提交个人信息前，向其出示本隐私政策并获取明示授权。</p>

        <p>1.3 当您作为律所或企业的最终使用用户时，为了实现您及团队的协同工作需求，您所提交的基本信息（姓名、手机号码、邮箱地址、角色信息）也将与您所在团队共享，并在您所在团队的用户管理模块中同步。</p>

        <p>1.4 为了向您提供隐私政策订阅服务，我们需要收集您在使用本服务过程中所输入的邮箱地址信息。</p>

        <p>1.5 如果因服务调整或功能更新而需超出前述范围收集、使用您的个人信息，我们将再次向您进行告知并重新获取您的授权。</p>

        <h3>2. 如何委托处理、共享、转让、公开披露您的信息</h3>
        <p>2.1 委托处理</p>
        <p>本服务的各功能模块均由iLaw自主提供，相关功能所需的个人信息也均由iLaw进行处理。如因开发新功能及模块而需引入第三方供应商的，我们将严格对其进行资质审核、签订数据保护协议与保密协议，同时在委托第三方供应商处理您的个人信息之前向您进行告知、并获取您的授权。</p>

        <p>2.2 共享</p>
        <p>除法律法规明确规定的其他情形外，未经您单独同意，我们不会向任何外部公司、组织和个人共享您的信息。</p>

        <p>2.3 转让</p>
        <p>我们不会将您的个人信息转让给任何公司、组织或个人，但相关法律法规所规定的如下情形除外：</p>
        <p>1）在获取您的明确授权同意后，我们会向其他方转让您的个人信息；</p>
        <p>2）在涉及合并、收购或破产清算时，如涉及个人信息的转让，我们会要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>

        <p>2.4 公开披露</p>
        <p>个人信息原则上不应公开披露，我们仅会在以下情形下，公开披露您的个人信息：</p>
        <p>1）事先获得您的明确授权同意；</p>
        <p>2）基于法律法规的明确规定。</p>

        <p>2.5 共享、转让、公开披露个人信息时需征得同意的例外</p>
        <p>请您知悉，依据相关法律法规的规定，基于以下情形共享、转让、公开披露您的个人信息时，无需征得您的同意：</p>
        <p>1）与个人信息控制者履行法律法规规定的义务相关的；</p>
        <p>2）与国家安全、国防安全直接相关的；</p>
        <p>3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p>4）与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
        <p>5）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>
        <p>6）个人信息主体自行向社会公众公开的个人信息；</p>
        <p>7）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>

        <h3>3. 如何存储、保护您的信息</h3>
        <p>3.1 信息的存储期限</p>
        <p>基于相关法律法规的规定，以及我们收集、使用个人信息的目的，我们仅在法律法规要求的时限及本隐私政策所明示目的所需的最短期限内存储您的信息。除非需要延长存储期限或受到法律的允许，否则我们将在个人信息收集目的完成后，及时予以删除或进行匿名化处理（经匿名化处理后的信息不再属于个人信息）。</p>
        <p>3.2 信息的存储地点</p>
        <p>我们所收集的信息将仅存储在中华人民共和国境内，并依据中华人民共和国相关法律法规予以保护。</p>
        <p>3.3 安全保护机制</p>
        <p>我们已使用符合业界标准的安全防护措施，防止信息遭到未经授权的访问、披露或攻击。同时，我们会采取一切合理可行的措施，保护您的个人信息，包括但不限于：</p>
        <p>3.3.1 我们将采取加密、脱敏、去标识等可行的技术措施，保障信息存储或传输过程中的安全性、保密性。</p>
        <p>3.3.2 我们将严格限定信息的访问权限，采取分级管理或审批机制，最小化管控可访问信息的必要人员范围。</p>
        <p>3.3.3 我们将定期对个人信息的保护情况进行确认并排查风险。</p>
        <p>3.3.4 如出现个人信息泄露等事件，我们将按照法律法规的要求及时向您告知或进行公告，并及时采取补救措施，我们还将按照监管部门的要求，主动上报个人信息安全事件的处置情况。</p>
        <p>我们十分重视您的个人信息安全，并将竭尽全力确保您所提交信息的安全性，但请您理解，互联网环境并非绝对安全，也请您注意保护您的账号密码等个人信息。</p>

        <h3>4. 如何使用Cookie技术</h3>
        <p>为保证本服务网站的正常运转，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件，我们可能会通过Cookie获得部分数据，通常包括：标识符、站点名称以及一些号码和字符，且这类数据会在您的计算机或移动设备上存储为Cookie数据文件。</p>
        <p>我们使用Cookie数据文件是为了判断注册用户的身份与登录情况，提升服务质量并优化用户的使用体验；同时，Cookie数据也可以帮助我们分析用户使用服务的情况。</p>
        <p>我们不会将Cookie用于本隐私政策所述目的之外的任何用途，如果您不希望前述信息保留在Cookie中，您可以通过浏览器设置阻止、清除Cookie。</p>

        <h3>5. 关于您的权利</h3>
        <p>我们将保障您对自己的个人信息行使如下权利：</p>
        <p>5.1 访问、更正您的个人信息</p>
        <p>除非法律法规另有规定，否则您有权访问您的个人信息；同时，如果您发现我们正在处理的关于您的个人信息存在错误时，您有权要求我们进行更正。您可以通过邮箱或电话联系我们，向我们提出访问、更正您个人信息的请求。</p>
        <p>为了保护用户个人信息安全，我们可能在受理前要求您提交您的身份信息，并对您的信息及请求内容进行验证，确保是个人信息主体发起的请求且请求内容符合法定条件。</p>
        <p>我们将在接到您的访问、更正请求之日起15个工作日内或法律法规所要求的时限内回复您的请求。</p>
        <p>5.2 删除您的个人信息</p>
        <p>在以下情形中，您可以向我们提出删除个人信息的请求，我们将及时予以删除：</p>
        <p>1）如果我们违反法律法规的规定，收集、使用、共享、披露您的个人信息；</p>
        <p>2）如果我们违反与您的约定而收集、使用、共享、披露您的个人信息；</p>
        <p>3）如果您不再使用我们的产品或服务，或您注销了账号；</p>
        <p>4）如果我们停止运营，不再为您提供产品或服务。</p>
        <p>对于删除请求，我们将在15个工作日内或法律法规所要求的时限内进行响应，在此期间，我们将严格地对您的信息进行安全存储与隔离，直至完成您所提起的请求。</p>
        <p>5.3 撤回同意</p>
        <p>您可以通过关闭相应功能服务或与我们取得联系等方式撤回您对我们收集个人信息的授权，或改变您的授权范围。</p>
        <p>部分业务功能的实现需要依赖基本的个人信息，如您选择撤回同意或授权，则我们将无法继续为您提供对应的服务。但您撤回同意或授权的决定，不会影响此前基于您的授权所开展的个人信息处理活动。</p>
        <p>5.4 注销账号</p>
        <p>您可以通过邮箱或电话联系我们请求注销您所注册的iLaw不动产账号，我们将在15个工作日内或法律法规所要求的时限内完成您的请求。</p>
        <p>当您完成账号的注销后，我们将停止为您提供相应的产品和服务，并删除相关个人信息或对信息进行匿名化处理，因法律法规另有规定而需要留存个人信息的除外。请您注意，如您选择注销账号，则您在本服务中的账号信息、项目资料等所有内容将一并清空，请您务必审慎操作，在注销账号前做好资料备份与权益清算等工作，以避免不必要的损失。</p>
        <p>5.5 获取个人信息副本</p>
        <p>您有权获取您的个人信息副本，在技术可行的前提下，我们将按照您的要求直接将您的个人信息副本（本人基本资料、身份信息）传输给您所指定的第三方。</p>
        <p>5.6 逝者近亲属的权利</p>
        <p>如用户不幸逝世，其近亲属可以通过邮箱或电话联系我们，行使关于账号个人信息的合法权利。</p>
        <p>5.7 请您理解，当出现以下情形时，您的前述请求将不被受理，届时我们会向您说明理由：</p>
        <p>1）与个人信息控制者履行法律法规规定的义务相关的；</p>
        <p>2）与国家安全、国防安全直接相关的；</p>
        <p>3）与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p>4）与刑事侦查、起诉、审判和执行判决等直接相关的；</p>
        <p>5）个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
        <p>6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>
        <p>7）响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；</p>
        <p>8）涉及商业秘密的。</p>

        <h3>6. 未成年人信息保护</h3>
        <p>本服务并不以未成年人为对象，不会主动收集未成年人的信息，但我们依然特别重视对未成年人信息的保护，如果我们需要收集未成年人信息，我们将会提前征得家长或监护人的明示授权同意，并出具单独的隐私政策。同时，我们敦请家长或监护人对未成年人的信息予以关注和保护，如您发现存在未成年人信息未经授权被收集、使用的情况，请您联系我们予以删除，并确保未成年人取消我们的服务。/或服务前，应事先取得您的家长或法定监护人的书面同意。</p>

        <h3>7. 本隐私政策更新</h3>
        <p>我们保留更新本隐私政策的权利，我们将在更新版本中对所调整内容进行说明，您可以随时在iLaw不动产官网（http://realestate.ilawhegui.cn）中查看最新版本协议内容；如果隐私政策出现重大变更或对您的权益有所影响，我们将在您登陆本服务时，以显著的方式通知您，并重新获取您的授权。</p>

        <h3>8. 如何联系我们</h3>
        <p>您可以通过登录iLaw不动产官网（http://realestate.ilawhegui.cn）通过在线客服的方式与我们联系，我们将在验证您的主体身份后15个工作日或法律法规要求的时限内，尽快予以答复。</p>
        <p>如您对我们的答复存在质疑，您还可以寻求外部途径维护您的权益：将争议提交至北京仲裁委员会，或向行业自律协会、政府相关管理机构寻求帮助。</p>
        <p style={{ textAlign: 'right' }}>北京新橙科技有限公司</p>
        <p style={{ textAlign: 'right' }}>2025年9月2日</p>
      </div>
    );
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      width={800}
      centered
      footer={[
        <Button key="close" onClick={onClose}>
          关闭
        </Button>,
        <Button
          key="agree"
          type="primary"
          onClick={onAgree}
        >
          确定
        </Button>,
      ]}
    >
      <div
        ref={contentRef}
        style={{
          maxHeight: '60vh',
          overflow: 'auto',
          padding: '16px',
        }}
      >
        {getContent()}
      </div>
    </Modal>
  );
}

export default AgreementModal;
